/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_baseIsNaN.js
// module id = 962
// module chunks = 15 16 17 18 19